import './social.css';

export function Social({ url, children }) {
  return (
    <a href={url} className="social" target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  );
}
